import FullscreenIcon from '@mui/icons-material/Fullscreen';

import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  carStatusSet,
  getCarStatus,
  getIsFullscreen,
} from '../../store/car-slice';

import FabControlled from '../../components/fab/fab-controlled';
import { enterFullScreen } from '../../utils/fullscreen';
import theme from '../../config/theme';

export default function FullscreenButton() {
  const dispatch = useDispatch();

  const carStatus = useSelector(getCarStatus);
  const isFullscreen = useSelector(getIsFullscreen);

  const FullscreenButtonStyle = styled(Box)<any>(() => ({
    position: carStatus === 'VDP' ? 'absolute' : 'fixed',
    right: '0.5rem',
    top: carStatus === 'VDP' ? '0.5rem' : undefined,
    bottom: carStatus !== 'VDP' ? '0.5rem' : undefined, // Set bottom when carStatus is not 'VDP'
    cursor: 'pointer',
  }));

  const handleFullscreen = () => {
    enterFullScreen(document.documentElement);
    if (carStatus === 'VDP') dispatch(carStatusSet('CAR'));
  };

  return (
    !isFullscreen &&
    carStatus !== 'CAR' && (
      <FullscreenButtonStyle onClick={handleFullscreen}>
        <Typography
          component="span"
          sx={{
            position: 'relative',
            background: 'rgba(30, 30, 30, 0.60)',
            color: 'white',
            borderRadius: '6px',
            marginRight: '8px',
            fontSize: '18px',
            padding: '1px 5px',
            zIndex: 9,
            [theme.breakpoints.down('lg')]: {
              fontSize: '12px',
            },
          }}
        >
          Full Screen
        </Typography>
        <FabControlled Icon={FullscreenIcon} />
      </FullscreenButtonStyle>
    )
  );
}
